import { Injectable, inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { firstValueFrom } from "rxjs";

@Injectable({ providedIn: "root" })
export class RoutePrefixRegistry {
  private readonly translate = inject(TranslateService);

  static allowedPrefixes: string[] = [];

  static getTranslated(key: string): string {
    return RoutePrefixRegistry.translations[key] || key;
  }

  static translations: Record<string, string> = {};

  async initAsync(): Promise<void> {
    const lang = this.translate.currentLang || this.translate.defaultLang;

    if (!this.translate.currentLang) {
      await firstValueFrom(this.translate.use(lang));
    }

    const vegetables = this.translate.instant("ROUTES.vegetables");
    const recipes = this.translate.instant("ROUTES.recipes");

    RoutePrefixRegistry.translations = {
      "ROUTES.vegetables": vegetables,
      "ROUTES.recipes": recipes,
    };

    RoutePrefixRegistry.allowedPrefixes = [vegetables, recipes];
  }
}
